import { useMemo } from 'react'
import { motion } from 'framer-motion'
import './Card.css'

export default function Card({ as = 'div', hoverLift = true, glow = false, className = '', children, ...rest }) {
  // motion.create() (unlike the cached motion.div/motion.form proxy properties)
  // builds a brand-new component type on every call — without memoizing it here,
  // Card would hand React a different element type each render, forcing a full
  // unmount/remount of everything inside (losing focus on any input mid-keystroke).
  const Component = useMemo(() => motion.create(as), [as])
  return (
    <Component
      className={`ll-card ${glow ? 'll-card--glow' : ''} ${className}`.trim()}
      whileHover={hoverLift ? { y: -4, borderColor: 'var(--border-hover)' } : undefined}
      transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
      {...rest}
    >
      {children}
    </Component>
  )
}
